import { render, staticRenderFns } from "./CustomerDetailsTooltip.vue?vue&type=template&id=6203d710"
import script from "./CustomerDetailsTooltip.vue?vue&type=script&lang=js"
export * from "./CustomerDetailsTooltip.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailsTooltip.vue?vue&type=style&index=0&id=6203d710&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports